function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo } from 'react';
// import { MClick } from '@jdhfe/seouifuncs/dist/mpass/mpMc';
import { getImgUrl } from '@jdhfe/seouifuncs/dist/tools/getImgUrl';
import style from "./TagList.less";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function NewTagListItem(props) {
  var _item$iconUrl;
  var item = props.item,
    idx = props.idx,
    data = props.data;
  return /*#__PURE__*/_jsxs("div", {
    className: "".concat(style.NewTagListItem, " ").concat(item.className)
    // className={`${style.NewTagListItem} newTag_priorityLevel_2`}
    ,
    onClick: item.onClick,
    children: [item.iconUrl && item.priorityLevel === 1 && /*#__PURE__*/_jsx("img", {
      className: "tag_zuiqiang_preImg",
      src: (_item$iconUrl = item.iconUrl) !== null && _item$iconUrl !== void 0 && _item$iconUrl.startsWith('jfs') ? getImgUrl(item.iconUrl) : item.iconUrl,
      alt: ""
    }), /*#__PURE__*/_jsx("span", {
      children: item.tagContent || item.tagName
    }), item.onClick && item.priorityLevel === 1 && /*#__PURE__*/_jsx("img", {
      className: "tag_zuiqiang_lastImg",
      src: "https://img14.360buyimg.com/imagetools/jfs/t1/246307/23/623/338/65892c0bF6aeed89c/a98f9ada8a750b46.png",
      alt: ""
    })]
  }, "".concat(item.tagField, "_").concat(idx));
}
export function NewTagList(props) {
  var data = props.data,
    tagSectionType = props.tagSectionType,
    cfg = props.cfg,
    cantClickTagFields = props.cantClickTagFields;
  // const { data = demo, tagSectionType, cfg ,cantClickTagFields} = props;

  var llistMap = useMemo(function () {
    var doctorLabel = data === null || data === void 0 ? void 0 : data.doctorLabel;
    var realType = tagSectionType;
    if (tagSectionType === 'marketingLabel') {
      realType = 'doctorLabel';
    }
    var lslist = doctorLabel === null || doctorLabel === void 0 ? void 0 : doctorLabel[realType];
    if (realType === 'doctorLabel') {
      return lslist === null || lslist === void 0 ? void 0 : lslist.map(function (item) {
        var cantClick = item.labelStyle !== 2 || (cantClickTagFields === null || cantClickTagFields === void 0 ? void 0 : cantClickTagFields.some(function (fid) {
          return fid === item.tagId;
        }));
        var extAttr = item === null || item === void 0 ? void 0 : item.extAttr;
        var iconUrl = '';
        if (extAttr) {
          try {
            var _JSON$parse;
            iconUrl = (_JSON$parse = JSON.parse(extAttr)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.iconUrl;
          } catch (e) {
            console.log(111, e);
          }
        }
        return _objectSpread(_objectSpread({}, item), {}, {
          tagName: item.tagName,
          tagField: item.tagId,
          tagContent: item.tagName,
          iconUrl: iconUrl,
          className: function () {
            return "newTag_priorityLevel_".concat(item.priorityLevel, " ").concat(cantClick ? 'tag_cantClick' : '');
          }()
        });
      });
    }
    return lslist === null || lslist === void 0 ? void 0 : lslist.map(function (item) {
      if (item.tagField === 'openRx' || item.tagField === 'notOpenRx') {
        item.tagContent = item.tagContent.replace('开方', '处方');
      }
      var cantClick = cantClickTagFields === null || cantClickTagFields === void 0 ? void 0 : cantClickTagFields.some(function (fid) {
        return fid === item.tagField;
      });
      return _objectSpread(_objectSpread({}, item), {}, {
        className: function () {
          return "tag_".concat(item.tagField, " ").concat(cantClick ? 'tag_cantClick' : '');
        }()
      });
    });
  }, [data]);
  if (!llistMap || !(llistMap !== null && llistMap !== void 0 && llistMap.length)) {
    return null;
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: llistMap === null || llistMap === void 0 ? void 0 : llistMap.map(function (item, idx) {
      return /*#__PURE__*/_jsx(NewTagListItem, {
        item: item,
        idx: idx,
        data: data
      }, "".concat(item.tagField, "_").concat(idx));
    })
  });
}